<template>
    <tile link="egrulz">
        <tile-title slot="tileHeader" icon="clock-o">Записи в {{ organ }}</tile-title>
        <div class="records" slot="tileContent">
            <egrul-records-table 
                v-if="records && records.length > 0"
                :records="recordsForTable" 
            />
            <modal 
                @throw-html="getHtml" 
                v-show="isModal" 
                :records="records"
                @close-modal="hideModal"
                :title="title"
                :companyName="companyName"
                :organ="organ"
            />
        </div>
        <div class="records-footer" slot="tileFooter">
            <tile-button @click.native="showModal">
                Все записи {{ organ }} ({{ records.length }}) и подробности
            </tile-button>
            <tilePrintPdf
                :html="htmlForPrint"
                filename="EGRUL"
                :title="title" 
                :printStyle="printStyle"
            />
        </div>
    </tile>
</template>

<script>
import tile from '@/components/ui/tile/tile.vue'
import tileTitle from '@/components/ui/tileTitle/tileTitle.vue'
import demoMessage from '@/components/ui/demoMessage/demoMessage.vue'
import tileButton from '@/components/ui/tileButton/tileButton.vue'
import tilePrintPdf from '@/components/ui/tilePrintPdf/tilePrintPdf.vue'
import egrulRecordsTable from '@/components/card/egrulRecords/egrulRecordsTable.vue'
import egrulRecordsModal from '@/components/card/egrulRecords/egrulRecordsModal.vue'

export default {
    components: {
        tile,
        tileTitle,
        demoMessage,
        egrulRecordsTable,
        tileButton,
        tilePrintPdf,
        modal: egrulRecordsModal
    },
    data: () => ({
        isModal: false,
        htmlForPrint: '',
        organ: 'ЕГРЮЛ',
        printStyle: `
            .print-main-title { 
                    border-bottom: 1px solid #4b6365;
                    color: #4b6365;
                    font-size: 25px;
                    margin-top: 0px;
                    margin-bottom: 0px;
                    text-align: center;
                    margin-bottom: 15px;
                    margin-top: 20px; 
            }
            .records-list { background: #eeeeef; padding: 20px;}
            .records-list ul { list-style-type: disc; }
            .record { border-bottom: 1px solid #9a9a9d; padding: 15px 0 }
        `
    }),
    computed: {
        records() { return this.$store.state?.card?.company?.egrul_records?.reverse() },
        recordsForTable() { return this.records?.length > 6 ? this.records.slice(0, 6) : this.records },
        companyName() {
            if(this.type === 'ip') {
                return this.$store.state.card?.company?.head_name ? `ИП ${this.$store.state.card?.company?.head_name}` : this.$store.state.card?.company?.title
            } else {
                return this.$store.state?.card?.company?.name_short || this.$store.state?.card?.company?.name_full 
            }
        },
        title() { return `Записи в ${this.organ} | ${this.companyName}` },
        type() { return this.$store.state.card?.company?.type }
    },
    methods: {
        showModal() { this.isModal = true },
        hideModal() { this.isModal = false },
        getHtml(html) { this.htmlForPrint = html }
    },
    mounted() {
        if(!this.records?.length > 0) {
            $('#egrulz-tile').hide()
            $('#tiles').trigger('resize')
        } else if(this.type === 'ip') {
            this.organ = 'ЕГРИП'
            $('#sliders-item-egrulz').find('span').text('Записи в ЕГРИП')
            $('#widemenu-item-egrulz').text('Записи в ЕГРИП')
        }
    }
}
</script>

<style lang="sass" scoped>
.records-footer
    width: 100%
    display: flex
    align-items: center
    justify-content: space-between
</style>